import type { ComponentChildren } from "preact";
import type { ReactNode } from "preact/compat";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import { useBranding } from "@brickme/d2c-branding/src/browser/context.tsx";
import MainMenu from "./main-menu.tsx";
import PoweredByBrickMe from "@brickme/frontend-common/src/ui/powered-by-brick-me.tsx";

type FullHeaderProps = {
	readonly children: ComponentChildren;
	readonly actions: readonly ReactNode[];
};

function FullHeader({ children, actions }: FullHeaderProps) {
	const t = useTranslator();
	const branding = useBranding();
	return (
		<div className="main-header-outer">
			<header className="main-header">
				<div className="main-header__container container-fluid">
					<div className="main-header__content row">
						<div className="main-header__aside-col col-md-3 col-sm-4 col-5">
							<MainMenu />
							<div className="main-header__logo">
								<a href="/" className="main-header__logo-link">
									<img
										src={branding.logoSquareSvg}
										alt={t("{companyName} Creator", {
											companyName: branding.companyName,
										})}
										className="main-header__logo-img"
									/>
									<span className="main-header__logo-descr-container">
										<span className="main-header__logo-descr d-none d-sm-block">
											{t("Creator")}
										</span>
										{branding.showPoweredBy && <PoweredByBrickMe />}
									</span>
								</a>
							</div>
						</div>
						<div className="main-header__col col-md-9 col-sm-8 col-7">
							{children}
							<div className="main-header__actions">{actions}</div>
						</div>
					</div>
				</div>
			</header>
		</div>
	);
}

export default FullHeader;
